import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import apiClient from "common/src/api/ApiClient";

export const fetchServiceAccountsPage = createAsyncThunk(
    'service-account/fetch/page',
    async ({page, filter, sort}, {dispatch}) => {
            const response = await apiClient.get(`/api/v1/service-accounts`, null, page, filter, sort);
            return response.data.payload;
    }
);
export const fetchServiceAccountDetails = createAsyncThunk(
    'service-account/fetch/details',
    async ({id}) => {
        const response = await apiClient.get('/api/v1/service-accounts/' + id);
        return response.data.payload;
    }
);

export const saveServiceAccount = createAsyncThunk(
    'service-account/save/details',
    async (serviceAccount, thunkAPI) => {
        try {
            let response;
            if (serviceAccount.id) {
                response = await apiClient.put(`/api/v1/service-accounts/${serviceAccount.id}`, serviceAccount);
            } else {
                response = await apiClient.post('/api/v1/service-accounts', serviceAccount);
            }

            return thunkAPI.fulfillWithValue(response.data.payload);
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);
const initialState = {
    list: [],
    page: {},
    loading: false,
    error: false,
    loadingDetails: false,
    details: {},
    entities: {}
};

const serviceAccountAPI = createSlice({
    name: 'serviceAccountAPI',
    initialState,
    reducers: {
      cleanList: (state, action) => {
        state.list = [];
        state.page = {};
        state.loading = true;
      }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchServiceAccountsPage.pending, (state, action) => {
                state.loading = true;
                state.error = false;
            })
            .addCase(fetchServiceAccountsPage.fulfilled, (state, action) => {
                state.loading = false;
                state.error = false;
                state.page = action.payload;
            })
            .addCase(fetchServiceAccountsPage.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
            })
            .addCase(fetchServiceAccountDetails.fulfilled, (state, action) => {
                state.details = action.payload;
            })
            .addCase(fetchServiceAccountDetails.pending, (state, action) => {
                state.detailsLoading = true;
            })
            .addCase(fetchServiceAccountDetails.rejected, (state, action) => {
                state.detailsLoading = false;
            })
            .addCase(saveServiceAccount.fulfilled, (state, action) => {
                // TODO simplify this - unnecessary complexity
                if (!state.page) {
                    state.page = {};
                    state.page.content = [];
                    state.page.totalElements = 0;
                    if (action?.meta.arg?.id) {
                        state.page.totalElements = state.page.totalElements + 1;
                    }
                }
                state.page.content ? state.page.content = state.page?.content?.map((serviceAccount) => {
                    if (serviceAccount.id === action?.payload?.id) {
                        return {...serviceAccount, ...action?.payload}
                    }
                    return serviceAccount;
                }) : state.page.content = [action?.payload];
                if (!action?.meta.arg?.id) {
                    state.page.totalElements = state.page.totalElements + 1;
                }
                state.savingBusy = false;
            })
            .addCase(saveServiceAccount.pending, (state, action) => {
                state.savingBusy = true;
            })
            .addCase(saveServiceAccount.rejected, (state, action) => {
                state.savingBusy = false;
            })
        ;
    },
});

export const {cleanList} = serviceAccountAPI.actions;


export default serviceAccountAPI.reducer;
